import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { logoutUser, logoutUserFromDaaraService } from '../actions/client';
import i18next from 'i18next';

const LogoutButton = (props) => (
    <li className={`dashboard__menu`}>
        <i style={{ marginLeft: i18next.dir() === 'rtl' ? '1rem' : 0 }} className={props.icon} />
        <button
            onClick={() => {
                const currentUrl = window.location.href;
                props.logout(currentUrl);
            }}
        >
            {props.title}
        </button>
    </li>
);

const mapDispatch = (dispatch) => ({
    logout: (redirectUrl) => {
        dispatch(logoutUserFromDaaraService(redirectUrl));
        dispatch(logoutUser(redirectUrl));
    }
});

export default withRouter(connect(null, mapDispatch)(LogoutButton));
